import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { useLenis } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import { OrderProvider } from "@/components/OrderProvider";
import TrackingLoader from "@/components/TrackingLoader";
import ComboMeals from "@/pages/ComboMeals";
import ALaCarte from "@/pages/ALaCarte";

import Catering from "@/pages/Catering";
import Featured from "@/pages/Featured";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <HelmetProvider>
      <div className="App grain">
        <BrowserRouter>
          <OrderProvider>
            <TrackingLoader />
            <ScrollToTop />
            <Header />
            <main className="relative z-10">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Navigate to="/menu/combos" replace />} />
                <Route path="/menu/combos" element={<ComboMeals />} />
                <Route path="/menu/a-la-carte" element={<ALaCarte />} />
                <Route path="/catering" element={<Catering />} />
                <Route path="/featured" element={<Featured />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
          </OrderProvider>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
